import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import '../../css/blog.css';
import Header from '../Header';
import Footer from '../Footer';
import LoadingScreen from '../../components/LoadingIndicator';
import { analytics } from '../../utils/common';
import { getPostBySlug, getBookUrlForSlug, hasPost } from '../../blog/posts';

const BlogPage = ({ match }) => {
  const slug = match && match.params ? match.params.slug : null;
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!slug || !hasPost(slug)) {
      setLoading(false);
      setError(true);
      return;
    }
    getPostBySlug(slug)
      .then(module => {
        setPost({
          title: module.title,
          metaDescription: module.metaDescription,
          Content: module.Content,
        });
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [slug]);

  // Page view for Segment/GA4 when blog post is loaded
  useEffect(() => {
    if (!post || !slug) return;
    analytics('Blog', {
      title: post.title,
      path: `/blog/${slug}`,
    });
  }, [post, slug]);

  if (error) {
    return <Redirect to="/" />;
  }

  if (loading || !post) {
    return <LoadingScreen />;
  }

  const { title: pageTitle, metaDescription, Content: PostContent } = post;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
        <link
          rel="canonical"
          href={`https://www.squeezemassage.com/blog/${slug}`}
        />
      </Helmet>
      <Header variant="blog" bookUrl={getBookUrlForSlug(slug)} />
      <main className="page-wrap blog-page">
        <article className="blog-page__article container">
          <PostContent
            bookUrl={getBookUrlForSlug(slug)}
            onBookClick={() =>
              analytics('Blog - Book a Massage', { slug, post_title: pageTitle }, true)
            }
          />
        </article>
      </main>
      <Footer variant="blog" />
    </>
  );
};

export default BlogPage;
